<template>
  <div>
    <div class="plans-notification" v-if="userResponse.has_never_subscribed == 'NO' && days <= 30 && !countLoader">
        <h6>{{ days }} : {{ hours }} : {{ minutes }} : {{ seconds }} <span class="dayss">days until smart subscription renewal!</span> <span class="membership"  v-if="days == 0 && hours == 0 && minutes == 0">Renew your Smart associate membership now</span> <span class="renew" v-if="days == 0 && hours == 0 && minutes == 0" @click="membership()">Renew now</span></h6>
        <!-- <h6>Plan not activated or has expired <span>Explore plans </span>to activate</h6> -->
    </div>
    <div class="welcome-banner">
      <div class="welcome-holder" v-if="user">
        <h1>
          Hi, <span>{{ user.firstname }}</span
          >!
        </h1>
        <span v-if="smartFM" class="fmio-text"><img src="../assets/images/fm-io.svg" alt="icon">Smart FM/IO</span>
        <!-- //TODO create function to display time of the day -->
      </div>
    </div>
  </div>
</template>
<script>
import partners from '../services/partners';

export default {
  components: {
  },

  data() {
    return {
      smartFM: false,
      countLoader: false,
      user: {},
      userResponse: "",
      userData: "",
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      countDown: {},
      subscriptionCountDown: {},
    };
  },
  computed: {
  },
  mounted() {
    this.userData = this.$store.getters.getUser;
    this.checkUserDetails();
    this.requestCountNumber(); 
  },
  methods: {
    checkUserDetails() {
      this.userResponse = JSON.parse(localStorage.getItem("smartUser"));
      this.user = JSON.parse(localStorage.getItem("smartUser")).user;
      // console.log("User", this.user)
      if (this.user && this.user.smartfm == 1) {
        return this.smartFM = true;
      }
    },
    membership() {
        return this.$root.$refs.D.openSubModal();
      },
      startCountdown() {
        this.countLoader = true;
         setInterval(() => {
               if (this.subscriptionCountDown?.expired == 'NO') {
                  const now = new Date().getTime();
                  const distance = new Date(this.subscriptionCountDown.expirydate).getTime() - now;
                  this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
                  this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                  this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                  this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
                  this.countDown = {
                     days: this.days,
                     hours: this.hours,
                     minutes: this.minutes,
                     seconds: this.seconds
                  }
                  this.countLoader = false;
               }
         }, 1000);
      },
      requestCountNumber() {
        this.countLoader = true;
         partners.requestCount(this.userData.id).then(res => {
        //  console.log("Count", res);
         this.startCountdown();
         this.subscriptionCountDown = res.subscription_expiration_counter;
         }).catch((err) => {
         console.log(err);
         })
      },
  },
  created() {
    this.$root.$refs.userx = this;
  }
  
};
</script>

<style scoped lang="scss">
$primary: #0033ea;
$white: #ffffff;
$yellow: #ffb100;
$asheGrey: #555C74;
$sheltaBlack: #2B3352;
.plans-notification {
    // background: $primary;
    background: #253f9b;
    min-height: 4px;
    padding: 24px;
    border-radius: 8px;
    h6 {
        color: $white;
        font-family: Lato;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-align: left;
        margin-bottom: 0;
        .dayss {
            font-weight: 400;
        }
        .membership {
            font-weight: 200;
        }
        .renew {
            cursor: pointer;
            font-weight: 700;
            border-bottom: 1px solid $white;
        }
    }
}
.welcome-banner {
  background: linear-gradient(90deg, #0033EA 0%, #000 100%), #0033EA;
  box-shadow: 5px 0px 4px 0px rgba(0, 0, 0, 0.05);
  /* background: linear-gradient(to bottom right, #0033ea 41.75%, #000000 119.38%),
    #0033ea; */
  color: #fff;
  padding: 2rem 1rem 2rem;
  font-family: "Lato", sans-serif;
  border-radius: 10px;
  margin-top: 1rem;
  // margin-right: 20px;
}

.welcome-holder {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fmio-text {
  font-size: 20px;
}

.welcome-banner h1 {
  font-weight: 300;
}
.welcome-banner span {
  font-weight: 700;
}

@media (max-width: 575.98px) {
  .welcome-banner h1 {
    font-size: 20px;
  }
  .fmio-text {
    font-size: 14px;
  }
}


</style>
